import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IDataConnectionAuthInfo } from './types/IDataConnectionAuthInfo';

export interface IGetDataConnectionAuthInfoParams {
  path: string;
  sessionId: string;
  attributes?: string;
}

export class GetDataConnectionAuthInfoRequest extends Request<IGetDataConnectionAuthInfoParams, IDataConnectionAuthInfo> {
  constructor(params: IGetDataConnectionAuthInfoParams) {
    super('getDataConnectionAuthInfo', params);
  }
}
